<template>
  <div v-if="sim_task_info" class="sim_task_profile">
    <div class="sim_task_profile__left">
      <div class="line row">
        <div class="col-md-6 col-sm-6">
          <fg-input v-model="sim_task_info.title" type="text"
                    :label="translate('sim_task.info.title')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="taskTypeLabel" type="text"
                    :label="translate('sim_task.compact.task_type')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input v-model="sim_task_info.status" type="text"
                    :label="translate('sim_task.info.status')" :readonly="true" />
        </div>
      </div>
      <div class="line row">
        <div class="col-md-3 col-sm-3">
          <fg-input :value="comp_created_at" type="text"
                    :label="translate('sim_task.info.created_at')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="comp_started_at" type="text"
                    :label="translate('sim_task.info.started_at')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="comp_finished_at" type="text"
                    :label="translate('sim_task.info.finished_at')" :readonly="true" />
        </div>
      </div>
      <div class="sim_task_profile__items-heading">
        <h4>{{ translate('sim_task.compact.sim_list') }}</h4>
        <button type="button" class="btn btn-default btn-sm" @click="$emit('update')">
          <i class="fa fa-refresh" aria-hidden="true"></i> {{ translate('sim_task.compact.refresh') }}
        </button>
      </div>
      <SimTaskSummary v-if="sim_task.summary" :summary="sim_task.summary" :is-apn-control="taskType === 'control_apn'" />
      <Items :items="items" />
    </div>
  </div>
</template>
<script>

import SimTaskSummary from "./Summary.vue";
import Items from "./Items/Items.vue";

export default {
  name: "SimTaskInfo",
  components: {
    Items,
    SimTaskSummary
  },

  props: {
    sim_task:{
      type: Object,
      required: true
    }
  },

  data () {
    return {
      sim_task_info: {}
    }
  },

  computed: {
    taskType () {
      const workflow = (this.sim_task_info.workflow_code || '').replace(/^manual_/, '')
      if (['block', 'unblock', 'sync_status', 'control_apn'].includes(workflow)) return workflow
      return { blocked: 'block', active: 'unblock', status_synced: 'sync_status', apn_present: 'control_apn' }[this.sim_task_info.target_result] || null
    },
    taskTypeLabel () {
      return this.taskType
        ? this.translate('sim_task.compact.task_types.' + this.taskType)
        : this.sim_task_info.workflow_code || '—'
    },
    items(){
      return this.sim_task.items || []
    },
    comp_planned_at(){
      return this.get_date(this.sim_task_info.planned_at)
    },
    comp_started_at(){
      return this.get_date(this.sim_task_info.started_at)
    },
    comp_finished_at(){
      return this.get_date(this.sim_task_info.finished_at)
    },
    comp_created_at(){
      return this.get_date(this.sim_task_info.created_at)
    },
    comp_updated_at(){
      return this.get_date(this.sim_task_info.updated_at)
    }
  },

  watch : {
    'sim_task.task': {
      immediate: true,
      handler (task) {
        this.sim_task_info = task ? JSON.parse(JSON.stringify(task)) : {}
      }
    }
  },

  methods: {

  }
}

</script>

<style lang='scss' scoped>
.sim_task_profile {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  &__left {
    width: 100%;
    min-width: 0;
    height: 100%;
    padding-right: 10px;
  }

  &__items-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 16px 0;
    h4 { margin: 0; }
  }
}

</style>
